import { getPhotosForPhotowall } from 'entities/photos';

Pixlee.module('PhotowallApp.Show', function(Show, App, Backbone, Marionette, $) {
    Show.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            var collectionView, headerView;
            var photoscollection = getPhotosForPhotowall();
            var layout = this.getLayout({
                collection: photoscollection
            });
            var _this = this;
            this.listenTo(layout, 'show', function() {
                collectionView = this.getCollectionView({
                    collection: photoscollection,
                    displayOptions: options.display_options
                });

                photoscollection.on('sync', function(collection, resp) {
                    if (_this.widgetloaded) {
                        return false;
                    }
                    _this.widgetloaded = true;
                    gon.sortType = resp.sortType;
                    App.commands.execute('opened:photowall', collection.pluck('album_photo_id'));
                });
                var headerLayout = _.isFalsy(options.display_options.headerOptions) ? '' : options.display_options.headerOptions.layout;

                headerView = this.getHeaderView({
                    model: App.currentAlbum
                });
                this.show(headerView, {
                    region: layout.widget_header_region
                });

                this.show(collectionView, {
                    region: layout.frame
                });
                if (!_.isFalsy(options.display_options.is_interactive)) {
                    var navbarView = this.getNavbarView(options, photoscollection);
                    this.show(navbarView, {
                        region: layout.interactive_region
                    });
                }
            });
            this.show(layout, {
                loading: true
            });
        },
        getLayout: function(options) {
            return new Show.Layout(options);
        },
        getCollectionView: function(options) {
            return new Show.PhotowallCollection(options);
        },
        getHeaderView: function(options) {
            return new Show.HeaderView(options);
        },
        getNavbarView: function(options, photoscollection) {
            return App.request('get:navbar:mobile:view', options, photoscollection);
        }
    });

});
